// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.object.set-prototype-of.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.object.set-prototype-of.js
// module chunks = 0